export enum Theme {
    Default,
    Dark,
}

export interface ThemeOption {
    value: Theme;
    label: string;
    folder: string;
}

export const THEMES: ThemeOption[] = [
    { value: Theme.Default, label: 'Light', folder: 'bootstrap4-light-blue' },
    { value: Theme.Dark,    label: 'Dark',  folder: 'bootstrap4-dark-blue'  },
];

export function themeFolder(theme: Theme): string {
    const found = THEMES.find(t => t.value === theme);
    return found ? found.folder : THEMES[0].folder;
}
